import React, { ComponentType } from 'react';
import { InputAttributes, NumericFormat, NumericFormatProps } from 'react-number-format';

import { Input } from '@ast/magma/components/input';

export const PERCENT_DECIMAL_SCALE = 2;
export const PERCENT_SYMBOL = '%';

export type PercentInputProps = NumericFormatProps & {label?: string | null};
export type PercentInputRef = NumericFormatProps;

export const PercentInput = React.forwardRef((props: PercentInputProps,
  ref: React.Ref<PercentInputRef>) => {
  const {
    onChange,
    ...numberFormatProps
  } = props;
  return (
    <NumericFormat
      fixedDecimalScale
      decimalScale={PERCENT_DECIMAL_SCALE}
      allowNegative
      data-stable-name="PercentInput"
      {...numberFormatProps}
      suffix={PERCENT_SYMBOL}
      allowLeadingZeros
      autoComplete="off"
      customInput={Input as ComponentType<InputAttributes> | undefined}
      inputMode="numeric"
      getInputRef={ref}
      onValueChange={(values: any) => {
        if (onChange) {
          onChange(values.floatValue !== undefined ? values.floatValue : null);
        }
      }}
    />
  );
});
